import { graphql } from "react-relay";

export const chromeMenuDrawerFragments = {
  viewer: graphql`
    fragment ChromeMenuDrawer_viewer on Viewer {
      user {
        id
        emails
        givenName
        familyName
        externalImageUrl
        dataSources(first: 1000000) {
          edges {
            node {
              id
              status
              name
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              domains
              experiments
              personForUserErrorable {
                __typename
                ... on GraphEntityError {
                  message
                }
                ... on Person {
                  id
                  primaryEmail
                  emails
                  primaryEmail
                  isYou
                  userId
                  isUser
                  profile {
                    givenName
                    familyName
                    externalImageUrl
                  }
                }
              }
              slackAccountsErrorable {
                __typename
                ... on SlackAccountList {
                  list {
                    id
                    slackTeamId
                    slackUserId
                    teamDisplayName
                  }
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
              }
              eventColoringSettingsErrorable {
                __typename
                ... on GraphEntityError {
                  statusCode
                  message
                }
                ... on EventColoringSettings {
                  eventCategoryColorings {
                    googleColorKey
                    eventCategory
                    active
                    isUserSet
                  }
                }
              }
              primaryTeam {
                __typename
                ... on Team {
                  teamId
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
              featureGrid {
                __typename
                ... on FeatureGrid {
                  stateMetadata {
                    primaryBillingGroupMetadata {
                      subscription {
                        id
                        type
                        productType
                      }
                    }
                  }
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
            }
          }
        }
      }
    }
  `,
};
